/** Keep in sync with constants.scss */
export const RIBBON_SLR_HEIGHT = 81;
export const RIBBON_MLR_HEIGHT = 133;
export const APP_RIBBON_SECTION = 'Ribbon';
